import { render, staticRenderFns } from "./MatchResultsStep.vue?vue&type=template&id=22f5a2d6"
import script from "./MatchResultsStep.vue?vue&type=script&lang=js"
export * from "./MatchResultsStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports